import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mom-responsive-modal-header',
  templateUrl: 'responsive-modal-header.component.html'
})
export class ResponsiveModalHeaderComponent {
  @Input() closeText = 'Close';
  @Input() confirmText: string;
  @Input() isConfirming: boolean;
  @Input() title: string;
  @Output() confirmed = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
}
